import React from 'react';
import { ShieldIcon, TrophyIcon, FlameIcon, CheckIcon } from 'lucide-react';
import { useLanguage } from '../context/LanguageContext';
export function RacingClasses() {
  const {
    t
  } = useLanguage();
  return <section id="classes" className="w-full bg-neutral-950 bg-noise py-20 md:py-28 px-4" data-id="element-384">
      <div className="max-w-7xl mx-auto" data-id="element-385">
        {/* Section Header */}
        <div className="text-center mb-16" data-id="element-386">
          <p className="text-orange-500 font-semibold text-sm uppercase tracking-[0.3em] mb-3" data-id="element-387">
            {t('classes.chooseChallenge')}
          </p>
          <h2 className="font-display text-4xl md:text-6xl tracking-wider text-white mb-4" data-id="element-388">
            {t('classes.title')}
          </h2>
          <p className="text-gray-400 text-lg max-w-2xl mx-auto" data-id="element-389">
            {t('classes.subtitle')}
          </p>
        </div>

        {/* Classes Grid */}
        <div className="grid grid-cols-1 md:grid-cols-3 gap-6 lg:gap-8" data-id="element-390">
          {/* Beginner Class */}
          <div className="relative group bg-neutral-900 border border-neutral-800 rounded-2xl overflow-hidden hover:border-green-500/50 transition-all duration-300" data-id="element-391">
            <div className="absolute top-0 left-0 right-0 h-1 bg-green-500" aria-hidden="true" data-id="element-392" />
            <div className="p-8" data-id="element-393">
              <div className="w-14 h-14 rounded-xl bg-green-500/10 flex items-center justify-center mb-6" data-id="element-394">
                <ShieldIcon className="h-7 w-7 text-green-500" data-id="element-395" />
              </div>
              <h3 className="font-display text-3xl tracking-wider text-white mb-2" data-id="element-396">
                {t('classes.beginner')}
              </h3>
              <p className="text-gray-400 mb-6" data-id="element-397">{t('classes.beginnerDesc')}</p>

              {/* Price */}
              <div className="mb-6" data-id="element-398">
                <span className="text-4xl font-bold text-white" data-id="element-399">€100</span>
                <span className="text-gray-500 ml-2" data-id="element-400">
                  {t('classes.perRider')}
                </span>
                <p className="text-green-500 text-sm font-semibold mt-1" data-id="element-401">
                  {t('classes.earlyBird')}
                </p>
              </div>

              {/* Requirements */}
              <div className="space-y-3 mb-8" data-id="element-402">
                <p className="text-xs font-semibold text-gray-500 uppercase tracking-wider mb-2" data-id="element-403">
                  {t('classes.requirements')}
                </p>
                <div className="flex items-start gap-3" data-id="element-404"></div>
                <div className="flex items-start gap-3" data-id="element-405">
                  <CheckIcon className="h-5 w-5 text-green-500 mt-0.5 flex-shrink-0" aria-hidden="true" data-id="element-406" />
                  <span className="text-gray-300 text-sm" data-id="element-407">
                    {t('classes.beginnerReq1')}
                  </span>
                </div>
                <div className="flex items-start gap-3" data-id="element-408">
                  <CheckIcon className="h-5 w-5 text-green-500 mt-0.5 flex-shrink-0" aria-hidden="true" data-id="element-409" />
                  <span className="text-gray-300 text-sm" data-id="element-410">
                    {t('classes.beginnerReq2')}
                  </span>
                </div>
                <div className="flex items-start gap-3" data-id="element-411">
                  <CheckIcon className="h-5 w-5 text-green-500 mt-0.5 flex-shrink-0" aria-hidden="true" data-id="element-412" />
                  <span className="text-gray-300 text-sm" data-id="element-413">
                    {t('classes.beginnerReq3')}
                  </span>
                </div>
                <div className="flex items-start gap-3" data-id="element-414">
                  <CheckIcon className="h-5 w-5 text-green-500 mt-0.5 flex-shrink-0" aria-hidden="true" data-id="element-415" />
                  <span className="text-gray-300 text-sm" data-id="element-416">
                    {t('classes.beginnerReq4')}
                  </span>
                </div>
              </div>

              {/* Details */}
              <div className="bg-neutral-800/50 rounded-xl p-4 mb-4" data-id="element-417">
                <div className="grid grid-cols-2 gap-4 text-center" data-id="element-418">
                  <div data-id="element-419">
                    <p className="text-2xl font-bold text-white" data-id="element-420">10 km</p>
                    <p className="text-xs text-gray-500 uppercase" data-id="element-421">
                      {t('classes.distance')}
                    </p>
                  </div>
                  <div data-id="element-422">
                    <p className="text-2xl font-bold text-white" data-id="element-423">3 st.</p>
                    <p className="text-xs text-gray-500 uppercase" data-id="element-424">
                      {t('classes.timeLimit')}
                    </p>
                  </div>
                </div>
              </div>
              <p className="text-xs text-gray-500 italic" data-id="element-425">
                {t('classes.scoringRule')}
              </p>
            </div>
          </div>

          {/* Hobby Class */}
          <div className="relative group bg-neutral-900 border border-neutral-800 rounded-2xl overflow-hidden hover:border-orange-500/50 transition-all duration-300 md:scale-105 md:shadow-2xl" data-id="element-426">
            <div className="absolute top-0 left-0 right-0 h-1 bg-orange-500" aria-hidden="true" data-id="element-427" />
            <div className="absolute top-4 right-4" data-id="element-428">
              <span className="px-3 py-1 bg-orange-500 text-black text-xs font-bold uppercase rounded-full" data-id="element-429">
                {t('classes.popular')}
              </span>
            </div>
            <div className="p-8" data-id="element-430">
              <div className="w-14 h-14 rounded-xl bg-orange-500/10 flex items-center justify-center mb-6" data-id="element-431">
                <TrophyIcon className="h-7 w-7 text-orange-500" data-id="element-432" />
              </div>
              <h3 className="font-display text-3xl tracking-wider text-white mb-2" data-id="element-433">
                {t('classes.hobby')}
              </h3>
              <p className="text-gray-400 mb-6" data-id="element-434">{t('classes.hobbyDesc')}</p>

              {/* Price */}
              <div className="mb-6" data-id="element-435">
                <span className="text-4xl font-bold text-white" data-id="element-436">€100</span>
                <span className="text-gray-500 ml-2" data-id="element-437">
                  {t('classes.perRider')}
                </span>
                <p className="text-green-500 text-sm font-semibold mt-1" data-id="element-438">
                  {t('classes.earlyBird')}
                </p>
              </div>

              {/* Requirements */}
              <div className="space-y-3 mb-8" data-id="element-439">
                <p className="text-xs font-semibold text-gray-500 uppercase tracking-wider mb-2" data-id="element-440">
                  {t('classes.requirements')}
                </p>
                <div className="flex items-start gap-3" data-id="element-441"></div>
                <div className="flex items-start gap-3" data-id="element-442">
                  <CheckIcon className="h-5 w-5 text-orange-500 mt-0.5 flex-shrink-0" aria-hidden="true" data-id="element-443" />
                  <span className="text-gray-300 text-sm" data-id="element-444">
                    {t('classes.hobbyReq1')}
                  </span>
                </div>
                <div className="flex items-start gap-3" data-id="element-445">
                  <CheckIcon className="h-5 w-5 text-orange-500 mt-0.5 flex-shrink-0" aria-hidden="true" data-id="element-446" />
                  <span className="text-gray-300 text-sm" data-id="element-447">
                    {t('classes.hobbyReq2')}
                  </span>
                </div>
                <div className="flex items-start gap-3" data-id="element-448">
                  <CheckIcon className="h-5 w-5 text-orange-500 mt-0.5 flex-shrink-0" aria-hidden="true" data-id="element-449" />
                  <span className="text-gray-300 text-sm" data-id="element-450">
                    {t('classes.hobbyReq3')}
                  </span>
                </div>
                <div className="flex items-start gap-3" data-id="element-451">
                  <CheckIcon className="h-5 w-5 text-orange-500 mt-0.5 flex-shrink-0" aria-hidden="true" data-id="element-452" />
                  <span className="text-gray-300 text-sm" data-id="element-453">
                    {t('classes.hobbyReq4')}
                  </span>
                </div>
              </div>

              {/* Details */}
              <div className="bg-neutral-800/50 rounded-xl p-4 mb-4" data-id="element-454">
                <div className="grid grid-cols-2 gap-4 text-center" data-id="element-455">
                  <div data-id="element-456">
                    <p className="text-2xl font-bold text-white" data-id="element-457">12 km</p>
                    <p className="text-xs text-gray-500 uppercase" data-id="element-458">
                      {t('classes.distance')}
                    </p>
                  </div>
                  <div data-id="element-459">
                    <p className="text-2xl font-bold text-white" data-id="element-460">3 st.</p>
                    <p className="text-xs text-gray-500 uppercase" data-id="element-461">
                      {t('classes.timeLimit')}
                    </p>
                  </div>
                </div>
              </div>
              <p className="text-xs text-gray-500 italic" data-id="element-462">
                {t('classes.scoringRule')}
              </p>
            </div>
          </div>

          {/* Pro Class */}
          <div className="relative group bg-neutral-900 border border-neutral-800 rounded-2xl overflow-hidden hover:border-red-500/50 transition-all duration-300" data-id="element-463">
            <div className="absolute top-0 left-0 right-0 h-1 bg-red-500" aria-hidden="true" data-id="element-464" />
            <div className="p-8" data-id="element-465">
              <div className="w-14 h-14 rounded-xl bg-red-500/10 flex items-center justify-center mb-6" data-id="element-466">
                <FlameIcon className="h-7 w-7 text-red-500" data-id="element-467" />
              </div>
              <h3 className="font-display text-3xl tracking-wider text-white mb-2" data-id="element-468">
                {t('classes.pro')}
              </h3>
              <p className="text-gray-400 mb-6" data-id="element-469">{t('classes.proDesc')}</p>

              {/* Price */}
              <div className="mb-6" data-id="element-470">
                <span className="text-4xl font-bold text-white" data-id="element-471">€100</span>
                <span className="text-gray-500 ml-2" data-id="element-472">
                  {t('classes.perRider')}
                </span>
                <p className="text-green-500 text-sm font-semibold mt-1" data-id="element-473">
                  {t('classes.earlyBird')}
                </p>
              </div>

              {/* Requirements */}
              <div className="space-y-3 mb-8" data-id="element-474">
                <p className="text-xs font-semibold text-gray-500 uppercase tracking-wider mb-2" data-id="element-475">
                  {t('classes.requirements')}
                </p>
                <div className="flex items-start gap-3" data-id="element-476"></div>
                <div className="flex items-start gap-3" data-id="element-477">
                  <CheckIcon className="h-5 w-5 text-red-500 mt-0.5 flex-shrink-0" aria-hidden="true" data-id="element-478" />
                  <span className="text-gray-300 text-sm" data-id="element-479">
                    {t('classes.proReq1')}
                  </span>
                </div>
                <div className="flex items-start gap-3" data-id="element-480">
                  <CheckIcon className="h-5 w-5 text-red-500 mt-0.5 flex-shrink-0" aria-hidden="true" data-id="element-481" />
                  <span className="text-gray-300 text-sm" data-id="element-482">
                    {'Pilns sacens\u012Bbu ekip\u0113jums ar ieteicamu kakla aizsargu'}
                  </span>
                </div>
                <div className="flex items-start gap-3" data-id="element-483">
                  <CheckIcon className="h-5 w-5 text-red-500 mt-0.5 flex-shrink-0" aria-hidden="true" data-id="element-484" />
                  <span className="text-gray-300 text-sm" data-id="element-485">
                    {t('classes.proReq3')}
                  </span>
                </div>
                <div className="flex items-start gap-3" data-id="element-486">
                  <CheckIcon className="h-5 w-5 text-red-500 mt-0.5 flex-shrink-0" aria-hidden="true" data-id="element-487" />
                  <span className="text-gray-300 text-sm" data-id="element-488">
                    {t('classes.proReq4')}
                  </span>
                </div>
              </div>

              {/* Details */}
              <div className="bg-neutral-800/50 rounded-xl p-4 mb-4" data-id="element-489">
                <div className="grid grid-cols-2 gap-4 text-center" data-id="element-490">
                  <div data-id="element-491">
                    <p className="text-2xl font-bold text-white" data-id="element-492">13 km</p>
                    <p className="text-xs text-gray-500 uppercase" data-id="element-493">
                      {t('classes.distance')}
                    </p>
                  </div>
                  <div data-id="element-494">
                    <p className="text-2xl font-bold text-white" data-id="element-495">3 st.</p>
                    <p className="text-xs text-gray-500 uppercase" data-id="element-496">
                      {t('classes.timeLimit')}
                    </p>
                  </div>
                </div>
              </div>
              <p className="text-xs text-gray-500 italic" data-id="element-497">
                {t('classes.scoringRule')}
              </p>
            </div>
          </div>
        </div>
      </div>
    </section>;
}